__turbopack_context__.v({
  "button": "thcpxq_button",
  "container": "thcpxq_container",
  "filter--tags": "thcpxq_filter--tags",
  "input": "thcpxq_input",
  "item": "thcpxq_item",
});
